import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { updateOrderProduct } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import { getCurrentDate } from "../../../helpers/dateParser";
import { ToastContainer } from "react-toastify";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function OrderProductEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  currentProduct,
}) {
  const { register, handleSubmit } = useForm({
    defaultValues: currentProduct,
  });

  const onSubmit = async (data) => {
    try {
      const body = {
        order_product_id: currentProduct.order_product_id,
        quantity: data.quantity,
        mc: data.mc,
        partial_amount: data.partial_amount,
        amount: data.amount,
        updated_by: getSessionData("user_id"),
        updated_at: getCurrentDate(),
      };

      // Replace with your API endpoint
      const response = await updateOrderProduct(body);
      if (response.statusCode === 200) {
        successToastify("Sales product updated successfully!");
        fetchData();
        setmodal_list(false);
      } else {
        // Handle error
        errorResponseHandler(response);
      }
    } catch (error) {
      // Handle error
      console.error("Error adding product:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal
        isOpen={modal_list}
        toggle={() => {
          tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          toggle={() => {
            tog_list();
          }}
        >
          Edit Sales Product
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="productName" className="form-label">
                Quantity
              </label>
              <input
                type="text"
                id="productName"
                className="form-control"
                placeholder="Enter Quantity"
                {...register("quantity", {
                  required: "Quantity is required",
                })}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="productName" className="form-label">
                MC
              </label>
              <input
                type="text"
                id="mc"
                className="form-control"
                placeholder="Enter MC"
                {...register("mc", {
                  required: "MC is required",
                })}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="productName" className="form-label">
                Partial Amount
              </label>
              <input
                type="text"
                id="partial_amount"
                className="form-control"
                placeholder="Enter Partial Amount"
                {...register("partial_amount", {
                  required: "Partial Amount is required",
                })}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="productName" className="form-label">
                Amount
              </label>
              <input
                type="text"
                id="amount"
                className="form-control"
                placeholder="Enter Amount"
                {...register("amount", {
                  required: "Amount is required",
                })}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Edit Sales Product
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

// Add prop types for validation
OrderProductEdit.propTypes = {
  modal_list: PropTypes.bool.isRequired, // Indicates if the modal is open
  setmodal_list: PropTypes.func.isRequired, // Function to toggle modal visibility
  tog_list: PropTypes.func.isRequired, // Function to toggle the modal
  fetchData: PropTypes.func.isRequired, // Function to fetch updated product data
  currentProduct: PropTypes.shape({
    product_id: PropTypes.number.isRequired, // The product ID being edited
    product_name: PropTypes.string.isRequired, // The product name being edited
  }).isRequired, // Current product details must be provided
};

export default OrderProductEdit;
